import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import { ToastContainer, toast } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";
import { Tooltip } from "./Tooltip";

const Contact = () => {
  const form = useRef();
  const [sendingMail, setSendingMail] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();
    setSendingMail(true);
    emailjs
      .sendForm(
        "service_s0z3j1g",
        "template_ps8f13r",
        form.current,
        "pcVoRLwZEicXAVMJ9"
      )
      .then(
        (result) => {
          document.getElementById("contact-form").reset();
          toast.success("Wiadomość wysłana pomyślnie!", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          console.log(result.text);
          setSendingMail(false);
        },
        (error) => {
          toast.error("Wystąpił błąd podczas wysyłania wiadomości.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          console.log(error.text);
          setSendingMail(false);
        }
      );
  };

  return (
    <section id="contact" className="section bg-light">
      <div className="container">
        <div className="row">
          <div className="col-lg-5 text-center text-lg-start wow fadeInUp">
            <h2 className="text-10 fw-600 mb-5">Skontaktuj się ze mną!</h2>
            <p className="text-5 mb-5">
              Chcesz zacząć rozwijać swoją firmę w internecie? Napisz do mnie, a wspólnie stworzymy angażujące treści wideo, które przyciągną klientów i zwiększą sprzedaż!
            </p>
<h3 className="text-5 fw-600">
              <i className="fas fa-map-marker-alt me-2"></i>
            Lokalizacja
            </h3>
            <address className="text-4">
              83-200, Starogard Gdański
            </address>

            <h3 className="text-5 fw-600">
              <i className="fas fa-envelope me-2"></i>
            Email:
            </h3>
            <p className="text-4">
              <a href="mailto:kontakt@makoskymedia.pl">
                kontakt@makoskymedia.pl
              </a>
            </p>

            <h3 className="text-5 fw-600">
              <i className="fas fa-phone me-2"></i>
              Nr. Tel:
            </h3>
            <p className="text-4">
              <a href="tel:+48451460682">451 460 682</a>
            </p>
            <ul className="social-icons social-icons-lg justify-content-center justify-content-lg-start mt-5">
              <li className="social-icons-facebook">
                <Tooltip text="Facebook" placement="top">
                  <a
                    href="https://www.facebook.com/makoskymedia"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-facebook" />
                  </a>
                </Tooltip>
              </li>
              <li className="social-icons-instagram">
                <Tooltip text="Instagram" placement="top">
                  <a
                    href="http://www.instagram.com/makosky.media"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-instagram" />
                  </a>
                </Tooltip>
              </li>
              <li className="social-icons-linkedin">
                <Tooltip text="LinkedIn" placement="top">
                  <a
                    href="https://www.linkedin.com/in/patryk-makowski-82136541a/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-linkedin-in" />
                  </a>
                </Tooltip>
              </li>

            </ul>
          </div>
          <div
            className="col-lg-6 ms-auto mt-5 mt-lg-0 wow fadeInUp"
            data-wow-delay="0.3s"
          >
            <h2 className="text-10 fw-600 text-center text-lg-start mb-5">
              Opisz swoją potrzebę:
            </h2>
            {/* Contact Form */}
            <form
              id="contact-form"
              className="form-border"
              method="post"
              ref={form}
              onSubmit={sendEmail}
            >
              <div className="row g-4">
                <div className="col-12">
                  <label className="form-label" htmlFor="name">
                    Imię i nazwisko/Nazwa firmy:
                  </label>
                  <input
                    id="name"
                    name="user_name"
                    type="text"
                    className="form-control py-1"
                    required
                  />
                </div>
                <div className="col-12">
                  <label className="form-label" htmlFor="email">
                    Adres email:
                  </label>
                  <input
                    id="email"
                    name="user_email"
                    type="email"
                    className="form-control py-1"
                    required
                  />
                </div>
                <div className="col-12">
                  <label className="form-label" htmlFor="form-message">
                    W czym mogę Ci pomóc?
                  </label>
                  <textarea
                    id="form-message"
                    name="message"
                    className="form-control py-1"
                    rows={4}
                    required
                    defaultValue={""}
                  />
                </div>
{/* Klauzula RODO / zgoda na przetwarzanie danych */}
                <div className="col-12">
                  <div className="form-check">
                    <input
                      id="privacy-consent"
                      name="privacy_consent"
                      type="checkbox"
                      className="form-check-input"
                      required
                    />
                    <label
                      className="form-check-label text-3"
                      htmlFor="privacy-consent"
                    >
                      Wyrażam zgodę na przetwarzanie moich danych osobowych
                      podanych w formularzu kontaktowym w celu udzielenia
                      odpowiedzi na przesłane zapytanie, zgodnie z{" "}
                      <a
                        href="/polityka-prywatnosci"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Polityką Prywatności
                      </a>
                      .
                    </label>
                  </div>
                </div>

                <div className="col-12 text-center text-lg-start">
                  <button
                    id="submit-btn"
                    className="btn btn-dark rounded-0"
                    type="submit"
                  >
                    {sendingMail ? (
                      <>
                        <span
                          role="status"
                          aria-hidden="true"
                          className="spinner-border spinner-border-sm align-self-center me-2"
                        ></span>
                        Wysyłanie......
                      </>
                    ) : (
                      <>
                        Wyślij{" "}
                        <span className="ms-3">
                          <i className="fas fa-arrow-right" />
                        </span>
                      </>
                    )}
                  </button>
                </div>
                <ToastContainer />
              </div>
            </form>
            {/* Contact Form end */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
